import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import SalesReportsLayer from "../components/SalesReportsLayer";

const SalesReportsPage = () => {
    return (
        <MasterLayout>
            <SalesReportsLayer />
        </MasterLayout>
    );
};

export default SalesReportsPage;
